import React, { useEffect, useState } from 'react';
import './style.css';
import { connect } from 'react-redux';
import { apiService } from '../../../_services/api.service';
import { APILoader } from '../../../components/APILoader';
import getColor from '../../../_helpers/getColor';
import getImageURL from '../../../_helpers/getImageURL';
import Modal from '../../../components/Modal';
import RatingForm from '../../../components/RatingForm';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const Ratings = ({ infosetting, user }) => {
    const [ratingList, setRatingList] = useState(null);
    const [selectedImage, setSelectedImage] = useState(null);
    const [reviewToEdit, setReviewToEdit] = useState(null);
    const [isLoading, setLoading] = useState(false);
    const navigate = useNavigate();
    useEffect(() => {
        if (infosetting) {
            document.title = `Ratings | ${infosetting.title}`;
        }
    }, [infosetting]);

    useEffect(() => {
        if (user) {
            fetchRatings();
        }
    }, [user]);

    const fetchRatings = () => {
        apiService.filter("adjuster-ratings", { query: { user: user._id } })
            .then(setRatingList);
    }

    const openImageModal = (imageUrl) => {
        setSelectedImage(imageUrl);
    };

    const closeImageModal = () => {
        setSelectedImage(null);
    };


    const onReviewSubmit = async (ratingValue, reviewText, images, isUpdate) => {
        try {
            setLoading(true);
            const submitData = new FormData();
            submitData.append('rating', ratingValue);
            submitData.append('review', reviewText);
            submitData.append('user', user._id);
            submitData.append('adjuster', reviewToEdit.adjuster);

            if (images.length > 0) {
                images.filter(img => img.preview.includes("data:image"))
                    .forEach((image) => {
                        submitData.append(`images`, image.file);
                    });


                let existing_images = images.filter(img => img.preview.includes("uploads")).map(image => { return { path: `/public/${image.preview.split("/public/")[1]}` } })
                if (existing_images.length > 0) {
                    submitData.append(`existing_images`, JSON.stringify(existing_images));
                }
            }

            await apiService.updateWithFile('adjuster-ratings', submitData, reviewToEdit._id);
            fetchRatings();
            setReviewToEdit(null);
            setLoading(false);

        } catch (e) {
            window.alert(e);
            toast.error(`An internal error occurred!`);
            setLoading(false);
        }

    }
    return (
        <div>
            <h3>Ratings</h3>
            {selectedImage && (
                <div className="image-modal-overlay" onClick={closeImageModal}>
                    <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
                        <button className="modal-close-button" onClick={closeImageModal}>×</button>
                        <img src={selectedImage} alt="Review attachment full size" className="modal-image" />
                    </div>
                </div>
            )}

            {user && <Modal isOpen={reviewToEdit ? true : false}
                title="Edit Review"
                onClose={() => setReviewToEdit(null)} >
                <RatingForm isLoading={isLoading} infosetting={infosetting} defaultData={reviewToEdit} onReviewSubmit={onReviewSubmit} />
            </Modal>}

            {ratingList ?
                ratingList.length > 0 ?
                    <div className='height60'>
                        {ratingList.map((rating, key) => <div className='adjuster-item row p-rating-item' key={key}>
                            <div className='a-rating-container column '>
                                <span className='a-rating-heading'>Rating</span>
                                <div className='a-rating-box row center' style={{ backgroundColor: getColor(rating.rating) }}>
                                    <span className='a-rating'>
                                        {rating.rating}{rating.rating.toString().length === 1 ? '.0' : ''}
                                    </span>
                                </div>
                            </div>
                            <div className='a-name-container column p-rating-item-name'>
                                <span className='a-name' onClick={() => navigate(`/adjuster/${rating.adjuster}`)}>{rating.adjusterObj.last_name}</span>
                                <span className='ap-review-text'>{rating.review}</span>

                                {rating.images && rating.images.length > 0 && (
                                    <div className="review-images-section">
                                        <h4>Photos ({rating.images.length})</h4>
                                        <div className="review-images">
                                            {rating.images.map((image) => (
                                                <div
                                                    key={image._id}
                                                    className="image-thumbnail-container"
                                                    onClick={() => openImageModal(getImageURL(image.path))}
                                                >
                                                    <img
                                                        src={getImageURL(image.path)}
                                                        alt="Review attachment"
                                                        className="image-thumbnail"
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className='a-state-container row'>
                                <div className='column a-state-container-adjuster-top'>
                                    <span className='a-state-name'>{new Date(rating.dateTime).toLocaleDateString()}</span>
                                    {user && rating.user === user._id && <span className='secondary-text edit-btn' onClick={() => setReviewToEdit(rating)}>Edit</span>}
                                </div>
                            </div>
                        </div>)}
                    </div>

                    :
                    <div className='column center height40 r-norating-found'>
                        <i class="fa-solid fa-star secondary-text"></i>
                        <h4 className='text-center'>No User Ratings Found: Please Rate Your Adjuster</h4>
                        <span className='text-center'>
                            We noticed you haven't rated any adjusters yet. Please find your adjuster and provide your valuable ratings and reviews to help us improve our services.</span>
                    </div>
                :
                <div className='column center height60'>
                    <APILoader />
                </div>}
        </div>
    );
};

function mapStateToProps(state) {
    return { ...state.authentication, ...state };
}

export default connect(mapStateToProps)(Ratings);